export default __webpack_public_path__ + "static/media/report.3de72712.svg";